import { render } from "./ListProductSection.vue?vue&type=template&id=2d58d8b3"
import script from "./ListProductSection.vue?vue&type=script&lang=js"
export * from "./ListProductSection.vue?vue&type=script&lang=js"

import "./ListProductSection.vue?vue&type=style&index=0&id=2d58d8b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__